import Highlighter from 'react-highlight-words';
import PropTypes from "prop-types";
import React from 'react';

const ResultProduct = ({
	image,
	shortTitle,
	price,
	isTopFive,
	index,
	itemProps,
	isHighlighted,
	inputValue
}) => {
	return (
		<li
			data-testid={`siteSearch-product-${index}`}
			className={`siteSearch__product ${
				isHighlighted ? 'siteSearch__term--is-highlighted' : ''
			} needsclick`}
			{...itemProps}>
			<div className="siteSearch__product-image-container">
				{isTopFive && (
					<img
						alt="Best Buy"
						className="siteSearch__bestbuy"
						src="//media.ao.com/Themes/Clients/AOL/AOL/Images/flags/lister/topFiveAward.png"
					/>
				)}
				<img
					className="siteSearch__product-image"
					src={`${image}`}
					alt={`${shortTitle}`}
				/>
			</div>

			<p className="siteSearch__product-title">
				<Highlighter
					highlightClassName="siteSearch__highlighted-text"
					searchWords={[inputValue]}
					autoEscape={true}
					highlightTag="strong"
					textToHighlight={shortTitle}
					data-testid="siteSearch-highlighted-text"
				/>
			</p>

			<p className="siteSearch__product-price pr-4">{price}</p>
		</li>
	);
};

ResultProduct.propTypes = {
	image: PropTypes.string,
	shortTitle: PropTypes.string,
	price: PropTypes.string,
	isTopFive: PropTypes.bool,
	index: PropTypes.any,
	itemProps: PropTypes.object,
	isHighlighted: PropTypes.bool,
	inputValue: PropTypes.string
}

export default ResultProduct;
